import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "reactstrap";
import uuidv4 from "uuid/v4";

const TooltipDiv = ({ containerClassName, text, tooltipText, tooltipPosition }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const uuid = useMemo(() => `t${uuidv4().replace(/-/g, "")}`, []);
  return (
    <div key={uuid} id={uuid} className={containerClassName}>
      {text}
      <Tooltip placement={tooltipPosition} isOpen={isOpen} target={uuid} toggle={toggle}>
        {tooltipText}
      </Tooltip>
    </div>
  );
};

TooltipDiv.propTypes = {
  containerClassName: PropTypes.string,
  text: PropTypes.string,
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltipPosition: PropTypes.string
};

TooltipDiv.defaultProps = {
  text: "",
  containerClassName: "",
  tooltipText: "",
  tooltipPosition: "top"
};

export default TooltipDiv;
